import React$1, { useState, useEffect } from 'react';
import PropTypes$1 from 'prop-types';
import Icon$1 from '../../basics/Icon/Icon.js';
import Grid$1 from '../Grid/Grid.js';
import Typography$1 from '../../basics/Typography/Typography.js';
import StyledFilter from './Filter.style.js';

/* eslint-disable react/no-array-index-key */

const Filter = ({
  options,
  labels,
  selected,
  onChange
}) => {
  const [open, setOpen] = useState(undefined);
  const [currentSelected, setCurrentSelected] = useState(selected || []);
  useEffect(() => {
    if (onChange && currentSelected.length !== selected.length) onChange(currentSelected);
  }, [currentSelected]);
  useEffect(() => {
    setCurrentSelected(selected);
  }, [selected]);

  const handleOpen = id => {
    if (open === id) return setOpen(undefined);
    return setOpen(id);
  };

  const removeFromSelected = id => {
    return setCurrentSelected(prev => prev.filter(item => item.id !== id));
  };

  const handleSelected = selectedItem => {
    if (currentSelected.find(item => item.id === selectedItem.id)) {
      return setCurrentSelected(prev => prev.filter(item => item.id !== selectedItem.id));
    }

    return setCurrentSelected(prev => [...prev, selectedItem]);
  };

  return /*#__PURE__*/React$1.createElement(StyledFilter, {
    open: Boolean(open)
  }, /*#__PURE__*/React$1.createElement(Grid$1, null, /*#__PURE__*/React$1.createElement("div", {
    className: "filter__groups"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "filter__groups-wrapper"
  }, labels.map(item => {
    return /*#__PURE__*/React$1.createElement("button", {
      type: "button",
      "aria-pressed": open === item.id,
      key: item.title,
      onClick: () => handleOpen(item.id)
    }, /*#__PURE__*/React$1.createElement(Typography$1, {
      as: "span"
    }, item.title), /*#__PURE__*/React$1.createElement(Icon$1, {
      icon: "downSmall"
    }));
  }))), labels.map(item => {
    return /*#__PURE__*/React$1.createElement("div", {
      key: item.title,
      className: "filter__values",
      "aria-hidden": open && open !== item.id
    }, options.filter(i => item.id === i.group).map(option => /*#__PURE__*/React$1.createElement("button", {
      type: "button",
      key: option.id,
      "aria-pressed": Boolean(currentSelected.find(i => i.id === option.id)),
      onClick: () => handleSelected(option)
    }, /*#__PURE__*/React$1.createElement(Typography$1, {
      as: "span"
    }, option.title.replace(/(\*)/g, '')))));
  }), currentSelected && currentSelected.length > 0 && /*#__PURE__*/React$1.createElement("div", {
    className: "filter__selected"
  }, /*#__PURE__*/React$1.createElement(Typography$1, {
    className: "filter__selected-title"
  }, "Deine Auswahl:"), currentSelected.map(item => /*#__PURE__*/React$1.createElement("button", {
    type: "button",
    key: item.id,
    onClick: () => removeFromSelected(item.id)
  }, /*#__PURE__*/React$1.createElement(Typography$1, {
    as: "span"
  }, item.title.replace(/(\*)/g, '')), /*#__PURE__*/React$1.createElement(Icon$1, {
    icon: "cross"
  }))))));
};

Filter.propTypes = {
  onChange: PropTypes$1.func,
  selected: PropTypes$1.arrayOf(PropTypes$1.string),
  labels: PropTypes$1.arrayOf(PropTypes$1.shape({
    title: PropTypes$1.string.isRequired,
    id: PropTypes$1.string.isRequired
  })).isRequired,
  options: PropTypes$1.arrayOf(PropTypes$1.shape({
    title: PropTypes$1.string.isRequired,
    id: PropTypes$1.string.isRequired
  })).isRequired
};
Filter.defaultProps = {
  selected: [],
  onChange: undefined
};

export default Filter;
